'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/help-text.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _componentThemes$help = _themes.componentThemes.helpInfo,
  helpTextStyle = _componentThemes$help.helpTextStyle,
  helpInfoTheme = _componentThemes$help.helpInfoTheme;
var helpTextStyles = function helpTextStyles(props) {
  var theme = helpInfoTheme(props.theme);
  return {
    transition: 'opacity .2s',
    opacity: props.transparent ? 0 : 1,
    position: theme[helpTextStyle('position')],
    left: theme[helpTextStyle('left')],
    marginBottom: theme[helpTextStyle('marginBottom')],
    top: theme[helpTextStyle('top')],
    marginLeft: theme[helpTextStyle('marginleft')],
    width: theme[helpTextStyle('width')]
  };
};
var Text = (0, _glamorous2.default)('div')(helpTextStyles);
var HelpText = function (_React$Component) {
  _inherits(HelpText, _React$Component);
  function HelpText() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, HelpText);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpText.__proto__ || Object.getPrototypeOf(HelpText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: _this.props.open,
      transparent: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Initialise the state with default values

  _createClass(HelpText, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var props = this.props;
      if (nextProps.open !== props.open) {
        if (nextProps.open) {
          // As soon as we are going to open the help text, set open to true and transparent to true
          // This will render the component in the dom with no opacity
          this.setState({
            open: true,
            transparent: true
          });
          setTimeout(function () {
            // After one tick we can set transparent to false, this will cause the open class
            // to be added to the component which will begin the transition to opaque.
            _this2.setState({
              open: true,
              transparent: false
            });
          });
        } else if (!nextProps.open) {
          // As soon as we are going to close the help text we set transparent to true to begin the transition.
          this.setState({
            open: true,
            transparent: true
          });
          setTimeout(function () {
            // After the transition has completed open is set to false to prevent the help text from being
            // rendered to the dom
            _this2.setState({
              open: false,
              transparent: true
            });
          }, 200);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
        open = _state.open,
        transparent = _state.transparent;
      var _props = this.props,
        theme = _props.theme,
        onClick = _props.onClick,
        children = _props.children,
        type = _props.type,
        propOpen = _props.open,
        rest = _objectWithoutProperties(_props, ['theme', 'onClick', 'children', 'type', 'open']);
      return open &&
      // We only render this component if it is open or fading to closed.
      _react2.default.createElement(Text, Object.assign({
        transparent: transparent
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        },
        __self: this
      }), _react2.default.createElement(_message2.default, {
        type: type,
        css: {
          '& > div': {
            paddingRight: theme.space_md
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        },
        __self: this
      }, _react2.default.createElement(_icon2.default, {
        type: 'cross',
        onClick: onClick,
        css: {
          position: 'absolute',
          top: 0,
          right: 0,
          margin: '10px',
          fontSize: '.7em',
          cursor: 'pointer'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80
        },
        __self: this
      }), children));
    }
  }]);
  return HelpText;
}(_react2.default.Component);
HelpText.propTypes = {
  children: _propTypes.node.isRequired,
  open: _propTypes.bool.isRequired,
  onClick: _propTypes.func.isRequired,
  type: (0, _propTypes.oneOf)(['help', 'warning']),
  theme: _propTypes.object.isRequired
};
HelpText.defaultProps = {
  type: 'help'
};
exports.default = (0, _glamorous.withTheme)(HelpText);